import { render, staticRenderFns } from "./AppLayoutBase.vue?vue&type=template&id=7448f694&scoped=true"
import script from "./AppLayoutBase.vue?vue&type=script&lang=ts"
export * from "./AppLayoutBase.vue?vue&type=script&lang=ts"
import style0 from "./AppLayoutBase.vue?vue&type=style&index=0&id=7448f694&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7448f694",
  null
  
)

export default component.exports